import { MiterIcon } from "ui2";

// The Miter header bar signals a real system of record, not a generic kiosk form.
export const AttendanceLayout = ({ children }: { children: React.ReactNode }): React.JSX.Element => (
  <div data-theme="new" className="tw:flex tw:h-dvh tw:flex-col tw:bg-off-white">
    <header className="tw:flex tw:shrink-0 tw:items-center tw:border-b tw:border-stroke tw:bg-white tw:px-4 tw:py-3">
      <MiterIcon />
    </header>
    <div className="tw:flex tw:min-h-0 tw:flex-1 tw:justify-center tw:sm:items-center tw:sm:p-6">
      <div className="tw:flex tw:min-h-0 tw:w-full tw:flex-col tw:overflow-y-auto tw:bg-white tw:sm:max-h-full tw:sm:min-h-[520px] tw:sm:max-w-xl tw:sm:rounded-sm tw:sm:border tw:sm:border-stroke tw:sm:shadow-sm">
        {children}
      </div>
    </div>
  </div>
);
